import React, { Component } from 'react'
import QuestionsList from './Quiz/QuestionsList'
import InfoPopup from './InfoPopup'
import ChooseAge from './ChooseAge'
import ResultsForm from './ResultsForm'
import axios from 'axios';
import Success from './Success';

export class Quiz extends Component {
  constructor() {
    super();
    this.state = {
      showPopup: true,
      showEmailPopup: false,
      showSuccessPopup: false,
      step: 1,
      link: '5',
      ageGroupID: undefined,
      responses: [],
      email: undefined,
      invalidEmail: false
    }
  }

  nextStep = () => {
    const { step } = this.state;
    this.setState({
      step: step + 1
    })
  }

  prevStep = () => {
    const { step } = this.state;
    this.setState({
      step: step - 1
    })
  }

  togglePopup() {
    this.setState({
      showPopup: !this.state.showPopup
    });
  }

  toggleEmailPopup() {
    this.setState({
      showEmailPopup: !this.state.showEmailPopup
    })
  }

  toggleSuccessPopup() {
    this.setState({
      showSuccessPopup: !this.state.showSuccessPopup
    });
  }

  handleChange = input => e => {
    this.setState({ [input]: e.target.value })
  }

  handleChangeForced = (input, e) => {
    this.setState({ [input]: e })
  }

  handlePayLoad = e => {
    const { responses } = this.state;
    let dontEnter = true;
    for (let i = 0; i < responses.length; i++) {
      if (e.category_id === responses[i].category_id) {
        responses[i] = e;
        dontEnter = false;
        break;
      }
    }
    if (dontEnter)
      responses.push(e);
  }



  POST_ACTION = () => {
    function ValidateEmail(email) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        return (true)
      }
      return (false)
    }

    if (ValidateEmail(this.state.email)) {
      axios.post('http://web.wholechildapp.com/api/quizzes',
        {
          email: this.state.email,
          age_group_id: this.state.link,
          type: 'web',
          responses: this.state.responses
        }).then(
          this.setState({
            showEmailPopup: false,
            showSuccessPopup: true

          })
        )
        .catch(function (error) {
          console.log(error);
        });
    }
    else {
      this.setState({
        invalidEmail: true
      })
    }
  }

  render() {
    const { step } = this.state;
    switch (step) {
      case 1:
        return (
          <ChooseAge
            handleChange={this.handleChange}
            handleChangeForced={this.handleChangeForced}
            nextStep={this.nextStep}
          />
        )
      case 2:
        return (
          <div>
            <QuestionsList
              api_link={this.state.link}
              handleChangeForced={this.handleChangeForced}
              handlePayLoad={this.handlePayLoad}
              responses={this.state.responses}
            />
            {this.state.showPopup ?
              <InfoPopup
                closePopup={this.togglePopup.bind(this)}
              />
              : null
            }
            {this.state.showEmailPopup ?
              <ResultsForm
                closeEmailPopup={this.toggleEmailPopup.bind(this)}
                invalidEmail={this.state.invalidEmail}
                handleChange={this.handleChange}
                POST_ACTION={this.POST_ACTION}
              />
              : null
            }
            {this.state.showSuccessPopup ?
              <Success
                OnSuccess={this.toggleSuccessPopup.bind(this)}
              /> : null}
          </div>
        )
    }
  }
}

export default Quiz
